import type { FaireProductEntity } from "../../entity_types/product";

export const p_u3gu88sgyj: FaireProductEntity = {
  token: "p_u3gu88sgyj",
  type: "product",
  name: "Margarita Frozen Cocktail -Just add Water + Tequila",
  brandToken: "b_kxk5df5zt5",
  brandName: "Noble Mick's - Craft Beverage Company",
  imageUrl:
    "https://cdn.faire.com/fastly/67b104ce1b0d77f659180e740ab3174eac610de106724c4790fe2204e86e4d8b.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/2609145cba55c522ed414bf3d9887cacca6eed1c0417fe59942f6eed390be887.png",
    "https://cdn.faire.com/fastly/1246d31703a1b092ad3a6a8b4b9b1e057517d880bed0e57ff39034f15f6e0544.png",
    "https://cdn.faire.com/fastly/1aa37eb03e6ad8b38d3d212562730157d0269a0e83c473c5dfc9bbff6ffe6701.png",
  ],
  priceDollars: 8.5,
  description:
    "Frozen Cocktails don't get easier than this! Each bag makes 8 servings. No blenders ever! Simply add 12oz Tequila and 36oz water shake or stir and throw in the freezer. \n\nOur Frozen cocktails are unique in you ONLY ever add water and spirit...NEVER any juice, mixers or additional flavors. That's one of the things that sets us apart. 100% all natural ingredients and perfect to share with friends and family at your next party. Cheers from Noble Mick's\n\n- 100% All-Natural Ingredients\n- Easy Prep:  Mix, Freeze & Serve Directly in the Bag \n- No Artificial Flavors or Colors\n- Made in the USA 🇺🇸\n- Vegan & Gluten-Free \n- Makes 8 Servings per Bag\n- No Blender Needed\n- Proven High Sell-Through\n- Strong Reorder Rate – Customer Favorite\n- Bold color and design makes merchandising a breeze!",
  tags: [],
  msrpDollars: 17,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-08-11T20:09:03.023Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
